var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-select",class:{ active: _vm.active },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon"),_c('span',{staticClass:"font-text",domProps:{"textContent":_vm._s(_vm.text)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }